var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AUDIO_EFFECT_NAME, getPreCfgByName } from '../audio-helper';
import BaseAudioEffector from './base-audio-effector';
/**
 * 均衡器效果
 */
var EqualizerEffector = /** @class */ (function (_super) {
    __extends(EqualizerEffector, _super);
    function EqualizerEffector(audioCtx, logger) {
        var _this = _super.call(this, audioCtx, logger) || this;
        // 十段均衡器控制声音频率，根据查阅声音相关资料相关定义：
        // 31~62Hz为超低频范围（鼓点、贝斯等），125~250Hz为低频范围（弦乐）,250~500Hz中低频（人声）
        // 500~1KHz低中频（大部分乐器），1K~2KHz中频（电吉他等），2K~4KHz中高频（影响语音清晰度）
        // 4K~8KHz高频（影响音色），8K~16KHz超高频(人能听到的高频范围)
        _this.audioFrequency = [31, 62, 125, 250, 500, 1000, 2000, 4000, 8000, 16000];
        // 定义2个频率高低频临界值，以决定使用哪种滤波器
        _this.lowHz = 62;
        _this.highHz = 8000;
        // 峰值滤波的质量因素值
        _this.peakQuality = 0.8;
        // 以指数方式接近目标值的速率常量，数值越大该过渡越慢
        _this.gainTimeConstant = 0.02;
        _this.effectorName = 'Equalizer';
        _this.inputNode = audioCtx.createGain();
        _this.outputNode = audioCtx.createGain();
        _this.biquadFilterList = [];
        return _this;
    }
    EqualizerEffector.prototype.connectBy = function (node) {
        if (!node || !this.inputNode) {
            return null;
        }
        // 如果没有创建滤波器，就按当前值默认创建一组
        if (this.biquadFilterList.length === 0) {
            this.setPreConfigName(AUDIO_EFFECT_NAME.DEFAULT);
        }
        // 内部节点已经连接了，返回连接第一个滤波节点，返回最后一个即可
        node.connect(this.inputNode);
        return this.outputNode;
    };
    EqualizerEffector.prototype.disconnect = function () {
        var _a;
        if (!this.outputNode) {
            return;
        }
        // 断掉最后节点即可，内部连接无需断开
        this.outputNode.disconnect();
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " disconnect()"));
    };
    EqualizerEffector.prototype.destroy = function () {
        var _a;
        if (!this.inputNode) {
            return;
        }
        // 内外音效节点均需要断开
        this.inputNode.disconnect();
        this.outputNode.disconnect();
        this.inputNode = null;
        this.outputNode = null;
        if (this.biquadFilterList.length === 0) {
            return;
        }
        this.biquadFilterList.forEach(function (biquadFilter) {
            biquadFilter.disconnect();
        });
        this.biquadFilterList.splice(0, this.biquadFilterList.length);
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("".concat(this.effectorName, " destroy()"));
        this.logger = null;
    };
    /**
     * 设置滤波器预设值，内含滤波器创建逻辑
     */
    EqualizerEffector.prototype.setPreConfigName = function (effectName) {
        var _a;
        if (effectName === this.currPreCfgName || !this.inputNode) {
            return;
        }
        this.currPreCfgName = effectName;
        var cfg = getPreCfgByName(effectName, eqPreCfgList);
        if (!cfg) {
            return;
        }
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log("EqualizerEffector setPreConfigName() effectName=".concat(effectName));
        var lastBiquadFilter = this.inputNode;
        for (var i = 0; i < this.audioFrequency.length; i++) {
            var frequency = this.audioFrequency[i];
            var biquadFilter = void 0;
            // 如果频率和滤波器数组长度不一样说明需要继续创建
            if (this.biquadFilterList.length !== this.audioFrequency.length) {
                biquadFilter = this.audioCtx.createBiquadFilter();
                this.biquadFilterList.push(biquadFilter);
                if (lastBiquadFilter) {
                    lastBiquadFilter.connect(biquadFilter);
                }
                // 最后一个节点就连接outputNode
                if (this.biquadFilterList.length === this.audioFrequency.length) {
                    biquadFilter.connect(this.outputNode);
                }
            }
            else {
                biquadFilter = this.biquadFilterList[i];
            }
            // 根据音频高低设置不同的滤波器参数
            if (frequency <= this.lowHz) {
                biquadFilter.type = biquadFilterType.LOWSHELF;
            }
            else if (frequency >= this.highHz) {
                biquadFilter.type = biquadFilterType.HIGHSHELF;
            }
            else {
                // 峰值滤波需要设置质量因素值
                biquadFilter.Q.value = this.peakQuality;
                biquadFilter.type = biquadFilterType.PEAKING;
            }
            // 设置当前频率到滤波器
            biquadFilter.frequency.setValueAtTime(frequency, this.audioCtx.currentTime);
            // 设置对应频率滤波器的音量大小
            biquadFilter.gain.setTargetAtTime(cfg.eq[i], this.audioCtx.currentTime, this.gainTimeConstant);
            lastBiquadFilter = biquadFilter;
        }
    };
    return EqualizerEffector;
}(BaseAudioEffector));
export default EqualizerEffector;
/**
 * EQ音效名称、中文名和预配置
 */
export var eqPreCfgList = [
    {
        name: AUDIO_EFFECT_NAME.DEFAULT,
        eq: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    }, {
        name: AUDIO_EFFECT_NAME.BASE_BOOSTER,
        eq: [6, 5, 5, 3, 1, 0, 0, 0, 0, 0],
    }, {
        name: AUDIO_EFFECT_NAME.VOCAL_BOOSTER,
        eq: [-2, -3, -3, 1, 4, 4, 3, 1, 0, -2],
    }, {
        name: AUDIO_EFFECT_NAME.VOCAL_WEAK,
        eq: [3, 2, 0, -1, -3, -3, -4, -3, -3, 2],
    }, {
        name: AUDIO_EFFECT_NAME.POP,
        eq: [-2, -1, 0, 2, 4, 4, 2, 0, -1, -2],
    }, {
        name: AUDIO_EFFECT_NAME.CLASSICAL,
        eq: [4.5, 4, 3, 2, -1, -1, 0, 2, 3, 4],
    }, {
        name: AUDIO_EFFECT_NAME.ELECTRONIC,
        eq: [5, 3, 1, 0, -2, 2, 0.5, 1, 4, 5],
    }, {
        name: AUDIO_EFFECT_NAME.GUITAR,
        eq: [-5, -3, -2, 2, -0.5, 0, 0, 2, 6, 0],
    }, {
        name: AUDIO_EFFECT_NAME.HIPHOP,
        eq: [5, 4, 1, 3, -1, -1, 1, -1, 2, 3],
    }, {
        name: AUDIO_EFFECT_NAME.JAZZ,
        eq: [4, 3, 1, 2, -2, -2, 0, 1, 3, 4],
    }, {
        name: AUDIO_EFFECT_NAME.RNB,
        eq: [3, 7, 6, 2, -3, -2, 2, 3, 3, 4],
    }, {
        name: AUDIO_EFFECT_NAME.ROCK_N_ROLL,
        eq: [5, 4, 3, 2, -1, -1, 1, 3, 4, 5],
    },
];
// 滤波器的过滤方式参数，相关文档非常专业，这里用最简单的方式描述一下
export var biquadFilterType;
(function (biquadFilterType) {
    // 默认值，允许低于该频率的信号通过，高频的则过滤掉
    biquadFilterType["LOWPASS"] = "lowpass";
    // 高频通过，低频过滤
    biquadFilterType["HIGHTPASS"] = "highpass";
    // bandpass带通是一个允许特定频段的波通过同时屏蔽其他频段
    // 允许频率有个公差(tolerance), 通过 Q（品质因素）来指定，Q值越大，频点附近宽度越窄，影响的频率区域也就越少
    biquadFilterType["BANDPASS"] = "bandpass";
    // 低频不够 就补偿低频
    biquadFilterType["LOWSHELF"] = "lowshelf";
    //  高频不够 就补偿高频
    biquadFilterType["HIGHSHELF"] = "highshelf";
    // 峰值滤波
    biquadFilterType["PEAKING"] = "peaking";
})(biquadFilterType || (biquadFilterType = {}));
